import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal, Grid, Table } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { closeModal } from "../../app/common/modals/modalReducer";
import { clonePackageFromTemplate, deletePackageTemplate, userConsultants, packageTemplates, getAuthUser } from "../quotes/quoteActions";
import { Formik } from "formik";
import MyTextInput from "../../app/common/form/MyTextInput";
import MySelectInput from "../../app/common/form/MySelectInput";
import subMonths from "date-fns/subMonths";

import firebase from "../../app/config/firebase";
const firestore = firebase.firestore();
const LOG_URL = "https://mytiny.inspireonline.co.za/api/v1/log.php";
const PACKAGE_TEMPLATES_INDEX_CACHE_PREFIX = "package_templates_index_cache_v1:";
const PACKAGE_TEMPLATES_CACHE_TTL_MS = 10 * 60 * 1000;
const MIN_INDEX_COUNT_FOR_ALL = 10;

export default function PackageTemplateCreateModal(props) {
    const { currentUserProfile } = useSelector((state) => state.profile);
    let dispatch = useDispatch();
    const [users, setusers] = useState([]);
    const [packagesRaw, setPackagesRaw] = useState([]);
    const [packageDetailsById, setPackageDetailsById] = useState({});
    const [chosenUser, setchosenUser] = useState(null);
    const [packageTemplatesList, setPackageTemplatesList] = useState([{ key: "", text: "None", value: "" }]);
    const [chosenPackage, setChosenPackage] = useState([]);
    const searchTimeoutRef = useRef(null);
    const clearedNoUserRef = useRef(false);
    const HISTORY_STORAGE_KEY = "package_templates_history_months_v1";
    const [historyMonths, setHistoryMonths] = useState(12);
    const [loadedHistoryMonths, setLoadedHistoryMonths] = useState(null);
    var parts = window.location.href.split("/");
    var lastSegment = parts.pop() || parts.pop();
    let quote = props.quote;
    const [deleting, setDeleting] = useState(false);

    const historyMonthOptions = [
        { key: 6, text: "Last 6 months", value: 6 },
        { key: 12, text: "Last 12 months", value: 12 },
        { key: 18, text: "Last 18 months", value: 18 },
        { key: 24, text: "Last 24 months", value: 24 },
        { key: "All", text: "All time", value: "All" },
    ];

    const getNetworkInfo = () => {
        if (typeof navigator === "undefined") return {};
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) return {};
        return {
            effectiveType: connection.effectiveType,
            downlink: connection.downlink,
            rtt: connection.rtt,
            saveData: connection.saveData,
        };
    };

    const resolveDate = (value) => {
        if (!value) return null;
        if (value.toDate) return value.toDate();
        if (value.seconds) return new Date(value.seconds * 1000);
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return null;
        return parsed;
    };

    const resolveTemplateDate = (template) => {
        if (!template) return null;
        return (
            resolveDate(template.createDate) ||
            resolveDate(template.createdAt) ||
            resolveDate(template.updatedAt) ||
            null
        );
    };

    const coversHistory = (loaded, requested) => {
        if (!loaded) return false;
        if (loaded === "All") return true;
        if (requested === "All") return false;
        const loadedValue = parseInt(loaded, 10);
        const requestedValue = parseInt(requested, 10);
        if (Number.isNaN(loadedValue) || Number.isNaN(requestedValue)) return false;
        return loadedValue >= requestedValue;
    };

    useEffect(() => {
        try {
            const stored = sessionStorage.getItem(HISTORY_STORAGE_KEY);
            if (stored) {
                if (stored === "All") {
                    setHistoryMonths("All");
                } else {
                    const parsed = parseInt(stored, 10);
                    setHistoryMonths(Number.isNaN(parsed) ? 12 : parsed);
                }
            }
        } catch (error) {
            // ignore storage errors
        }
    }, []);

    useEffect(() => {
        try {
            sessionStorage.setItem(HISTORY_STORAGE_KEY, String(historyMonths));
        } catch (error) {
            // ignore storage errors
        }
    }, [historyMonths]);

    useEffect(() => {
        if (!chosenUser) return;
        const keepKey = `${PACKAGE_TEMPLATES_INDEX_CACHE_PREFIX}${chosenUser}:${historyMonths}`;
        try {
            for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
                const key = sessionStorage.key(i);
                if (!key) continue;
                if (key.startsWith(`${PACKAGE_TEMPLATES_INDEX_CACHE_PREFIX}${chosenUser}:`) && key !== keepKey) {
                    sessionStorage.removeItem(key);
                }
            }
        } catch (error) {
            // ignore storage errors
        }
    }, [historyMonths, chosenUser]);

    useEffect(() => {
        if (currentUserProfile?.id) {
            setchosenUser(currentUserProfile?.id);
        }
    }, [currentUserProfile]);

    useEffect(() => {
        const unsubscribe = firestore
            .collection("users")
            .where("isConsultant", "==", true)
            .onSnapshot((snapshot) => {
                let userlist = [];
                snapshot.docs.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), id: doc.id };
                        userlist.push(appObj);
                    }
                });
                userlist.sort((a, b) => (a.displayName > b.displayName ? 1 : -1));

                userlist = userlist.map(function (pt) {
                    return {
                        key: pt.id,
                        text: pt.displayName,
                        value: pt.id,
                    };
                });

                setusers(userlist);
            });

        return () => unsubscribe();
    }, []);

    const applyPackageTemplates = useCallback(
        (packageList, options = {}) => {
            const processStartMs = Date.now();
            let historyStart = null;
            if (historyMonths !== "All") {
                const parsed = parseInt(historyMonths, 10);
                if (!Number.isNaN(parsed)) {
                    historyStart = subMonths(new Date(), parsed);
                }
            }
            let missingCreatedAt = 0;

            const filtered = packageList.filter((pt) => {
                if (pt.isArchived === true) {
                    return false;
                }
                const createdAt = resolveTemplateDate(pt);
                if (!createdAt) {
                    missingCreatedAt += 1;
                    return true;
                }
                if (!historyStart) return true;
                return createdAt >= historyStart;
            });

            filtered.sort((a, b) => (a.template_name > b.template_name ? 1 : -1));

            setPackageTemplatesList(
                filtered.map(function (pt) {
                    return {
                        key: pt.id,
                        text: pt.template_name + " (" + pt.package_name + ")",
                        value: pt.id,
                    };
                })
            );

            let payloadBytes = 0;
            try {
                payloadBytes = JSON.stringify(filtered).length;
            } catch (error) {
                payloadBytes = 0;
            }

            const processMs = Date.now() - processStartMs;
            const fetchMs = options.fetchMs || 0;
            const totalMs = fetchMs + processMs;

            fetch(LOG_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-TEST-KEY": "temp123",
                },
                body: JSON.stringify({
                    action: "package_template_list",
                    durationMs: totalMs,
                    fetchMs,
                    processMs,
                    cacheHit: options.cacheHit || false,
                    source: options.source || "",
                    cacheKey: options.cacheKey || "",
                    indexCount: options.indexCount ?? null,
                    legacyCount: options.legacyCount ?? null,
                    userId: currentUserProfile?.id || "",
                    displayName: currentUserProfile?.displayName || "",
                    email: currentUserProfile?.email || "",
                    chosenUser: chosenUser || "",
                    historyMonths,
                    count: filtered.length,
                    rawCount: packageList.length,
                    missingCreatedAt,
                    payloadBytes,
                    network: getNetworkInfo(),
                    ts: new Date().toISOString(),
                }),
            }).catch((error) => console.log("[perf] log failed", error?.message || error));
        },
        [chosenUser, currentUserProfile, historyMonths]
    );

    useEffect(() => {
        if (!chosenUser) {
            if (clearedNoUserRef.current) {
                return;
            }
            clearedNoUserRef.current = true;
            setPackagesRaw([]);
            setPackageTemplatesList([{ key: "", text: "None", value: "" }]);
            setLoadedHistoryMonths(null);
            return;
        }
        clearedNoUserRef.current = false;

        const cacheKey = `${PACKAGE_TEMPLATES_INDEX_CACHE_PREFIX}${chosenUser}:${historyMonths}`;

        if (loadedHistoryMonths === historyMonths && packagesRaw.length > 0) {
            applyPackageTemplates(packagesRaw, { cacheHit: true, source: "memory_loaded", cacheKey });
            return;
        }

        if (packagesRaw.length >= MIN_INDEX_COUNT_FOR_ALL && coversHistory(loadedHistoryMonths, historyMonths)) {
            applyPackageTemplates(packagesRaw, { cacheHit: true, source: "memory_superset", cacheKey });
            return;
        }
        let cached = null;
        try {
            cached = JSON.parse(sessionStorage.getItem(cacheKey));
        } catch (error) {
            cached = null;
        }

        if (
            cached &&
            Array.isArray(cached.data) &&
            cached.data.length >= MIN_INDEX_COUNT_FOR_ALL &&
            Date.now() - cached.ts < PACKAGE_TEMPLATES_CACHE_TTL_MS
        ) {
            setPackagesRaw(cached.data);
            setLoadedHistoryMonths(historyMonths);
            applyPackageTemplates(cached.data, { cacheHit: true, source: "cache", cacheKey });
            return;
        }

        const fetchIndex = () => {
            const snapStartMs = Date.now();
            let query = firestore.collection("package_templates_index").where("userUid", "==", chosenUser);
            let historyStart = null;
            if (historyMonths !== "All") {
                const parsed = parseInt(historyMonths, 10);
                if (!Number.isNaN(parsed)) {
                    historyStart = subMonths(new Date(), parsed);
                }
            }
            if (historyStart) {
                query = query.where("createdAt", ">=", historyStart).orderBy("createdAt", "asc");
            }
            return query.get().then((snapshot) => {
                let packageList = [];
                snapshot.docs.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), id: doc.id };
                        packageList.push(appObj);
                    }
                });
                    return { list: packageList, fetchMs: Date.now() - snapStartMs, source: "index", indexCount: packageList.length };
                });
        };

        const fetchLegacy = () => {
            const snapStartMs = Date.now();
            return firestore
                .collection("package_templates")
                .where("userUid", "==", chosenUser)
                .get()
                .then((snapshot) => {
                    let packageList = [];
                    snapshot.docs.forEach((doc) => {
                        if (doc.exists) {
                            const data = doc.data();
                            let appObj = {
                                id: doc.id,
                                userUid: data.userUid,
                                template_name: data.template_name,
                                package_name: data.package_name,
                                createDate: data.createDate,
                                createdAt: data.createdAt,
                                updatedAt: data.updatedAt,
                            };
                            packageList.push(appObj);
                        }
                    });
                    return { list: packageList, fetchMs: Date.now() - snapStartMs, source: "legacy", legacyCount: packageList.length };
                });
        };

        fetchIndex()
            .then((res) => {
                if (!res.list || res.list.length === 0) {
                    return fetchLegacy().then((legacyRes) => ({ ...legacyRes, source: "legacy_fallback", indexCount: 0 }));
                }
                if (res.list.length < MIN_INDEX_COUNT_FOR_ALL) {
                    return fetchLegacy().then((legacyRes) => ({
                        ...legacyRes,
                        source: "legacy_low_count_fallback",
                        indexCount: res.list.length,
                        legacyCount: legacyRes.list ? legacyRes.list.length : legacyRes.legacyCount,
                    }));
                }
                return res;
            })
            .then((res) => {
                if (!res || !res.list) return;
                setPackagesRaw(res.list);
                setLoadedHistoryMonths(historyMonths);
                try {
                    sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), data: res.list }));
                } catch (error) {
                    // ignore cache errors
                }
                applyPackageTemplates(res.list, {
                    fetchMs: res.fetchMs,
                    cacheHit: false,
                    source: res.source,
                    cacheKey,
                    indexCount: res.indexCount ?? null,
                    legacyCount: res.legacyCount ?? null,
                });
            })
            .catch(() => {
                fetchLegacy().then((res) => {
                    if (!res || !res.list) return;
                    setPackagesRaw(res.list);
                    setLoadedHistoryMonths(historyMonths);
                    try {
                        sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), data: res.list }));
                    } catch (error) {
                        // ignore cache errors
                    }
                    applyPackageTemplates(res.list, {
                        fetchMs: res.fetchMs,
                        cacheHit: false,
                        source: "legacy_error_fallback",
                        cacheKey,
                        legacyCount: res.legacyCount ?? null,
                    });
                });
            });
    }, [chosenUser, historyMonths, loadedHistoryMonths, packagesRaw, applyPackageTemplates]);

    // let usersList = [];
    // users.sort((a, b) => (a.displayName > b.displayName ? 1 : -1));
    // usersList = users.map(function (pt) {
    //     return {
    //         key: pt.id,
    //         text: pt.displayName,
    //         value: pt.id,
    //     };
    // });

    const updateUser = useCallback((value) => {
        setchosenUser(value);
    }, []);

    function updateChosenUser(value) {
        updateUser(value.value);
    }

    function handleTemplateSearch(e, data) {
        const term = (data?.searchQuery || "").trim();
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        if (term.length < 2) return;
        searchTimeoutRef.current = setTimeout(() => {
            fetch(LOG_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-TEST-KEY": "temp123"
                },
                    body: JSON.stringify({
                        action: "package_template_search",
                        term,
                        termLength: term.length,
                        userId: currentUserProfile?.id || "",
                        displayName: currentUserProfile?.displayName || "",
                        email: currentUserProfile?.email || "",
                        chosenUser: chosenUser || "",
                        historyMonths,
                        ts: new Date().toISOString(),
                    }),
            }).catch((error) => console.log("[perf] log failed", error?.message || error));
        }, 300);
    }

    const updatePackages = useCallback((value) => {
        // console.log(value)
        setChosenPackage(value);
    }, []);

    function loadTemplate(value) {
        const templateId = value?.value;
        if (!templateId) {
            updatePackages([]);
            return;
        }

        if (packageDetailsById[templateId]) {
            updatePackages(packageDetailsById[templateId]);
            return;
        }

        const detailStartMs = Date.now();
        firestore
            .collection("package_templates")
            .doc(templateId)
            .get()
            .then((doc) => {
                if (!doc.exists) return;
                const data = { ...doc.data(), id: doc.id };
                setPackageDetailsById((prev) => ({ ...prev, [templateId]: data }));
                updatePackages(data);
                fetch(LOG_URL, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-TEST-KEY": "temp123",
                    },
                    body: JSON.stringify({
                        action: "package_template_detail_load",
                        durationMs: Date.now() - detailStartMs,
                        userId: currentUserProfile?.id || "",
                        displayName: currentUserProfile?.displayName || "",
                        email: currentUserProfile?.email || "",
                        chosenUser: chosenUser || "",
                        templateId,
                        historyMonths,
                        network: getNetworkInfo(),
                        ts: new Date().toISOString(),
                    }),
                }).catch((error) => console.log("[perf] log failed", error?.message || error));
            });
    }

    async function deletePackage() {
        setDeleting(true);

        console.log(chosenPackage);

        await deletePackageTemplate(chosenPackage, props.quote);

        setDeleting(false);
    }

    return (
        <>
            <Modal size="large" open={true} onClose={() => dispatch(closeModal())}>
                <Modal.Content>
                    <Modal.Description>
                        <Formik
                            initialValues={{ new_package_name: "", package_template_id: "" }}
                            enableReinitialize="true"
                            validate={(values) => {
                                const error = {};
                                return error;
                            }}
                            onSubmit={async (values, { setSubmitting }) => {
                                quote.id = lastSegment;
                                await clonePackageFromTemplate(values, quote);

                                setSubmitting(false);
                                dispatch(closeModal());
                            }}
                            onChange={(value) => { }}
                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, field, setFieldValue }) => (
                                <form onSubmit={handleSubmit} className="ui form">
                                    <Grid>
                                        <Grid.Row columns={5}>
                                            <Grid.Column width={3}>
                                                <MyTextInput label="" labelTop="Step 1: Package Name" name="new_package_name" type="text" />
                                            </Grid.Column>

                                            <Grid.Column width={3}>
                                                <MySelectInput
                                                    label=""
                                                    labelTop="Step 2: Choose a User"
                                                    name="chosenUser"
                                                    options={users}
                                                    onChange={(field, value) => updateChosenUser(value)}
                                                    value={chosenUser}
                                                    placeholder="Select a User"
                                                    legacy={true}
                                                />
                                            </Grid.Column>

                                            <Grid.Column width={2}>
                                                <MySelectInput
                                                    label=""
                                                    labelTop="History"
                                                    name="templateHistoryMonths"
                                                    options={historyMonthOptions}
                                                    value={historyMonths}
                                                    placeholder="Last 12 months"
                                                    onChange={(field, value) => setHistoryMonths(value.value)}
                                                    legacy={true}
                                                />
                                            </Grid.Column>

                                            <Grid.Column width={3}>
                                                <MySelectInput
                                                    label=""
                                                    labelTop="Step 3: Choose a Template"
                                                    name="package_template_id"
                                                    options={packageTemplatesList}
                                                    value={values.package_template_id}
                                                    placeholder="Select a Package Template"
                                                    onChange={(field, value) => {
                                                        loadTemplate(value);
                                                        setFieldValue("package_template_id", value.value);
                                                    }}
                                                    onSearchChange={handleTemplateSearch}
                                                    legacy={true}
                                                />
                                            </Grid.Column>
                                            <Grid.Column width={5}>
                                                <div>Step 4: Clone</div>

                                                <Button disabled={isSubmitting} loading={isSubmitting} color="orange" content="Create Cloned Package" type="submit" />
                                                <Button disabled={deleting} loading={deleting} color="red" content="Delete Package" onClick={deletePackage} />
                                                <Button disabled={isSubmitting} color="grey" content="Cancel" onClick={() => dispatch(closeModal())} />
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </form>
                            )}
                        </Formik>

                        {chosenPackage && chosenPackage.id && (
                            <Table celled style={{ marginTop: 20 }}>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            <strong>Package ID</strong>
                                        </Table.Cell>
                                        <Table.Cell>{chosenPackage.id}</Table.Cell>
                                        <Table.Cell></Table.Cell>
                                        <Table.Cell></Table.Cell>
                                    </Table.Row>

                                    <Table.Row>
                                        <Table.Cell>
                                            <strong>Package Name</strong>
                                        </Table.Cell>
                                        <Table.Cell>{chosenPackage.package_name}</Table.Cell>
                                        <Table.Cell>
                                            <strong>Price</strong>
                                        </Table.Cell>
                                        <Table.Cell>{chosenPackage.price}</Table.Cell>
                                    </Table.Row>

                                    <Table.Row>
                                        <Table.Cell>
                                            <strong>Holiday</strong>
                                        </Table.Cell>
                                        <Table.Cell>{chosenPackage.holiday_name}</Table.Cell>
                                        <Table.Cell>
                                            <strong>Discount</strong>
                                        </Table.Cell>
                                        <Table.Cell>{chosenPackage.discount}</Table.Cell>
                                    </Table.Row>

                                    {chosenPackage.price_breakdown && (
                                        <Table.Row>
                                            <Table.Cell colSpan="4">
                                                <strong>Price Breakdown</strong>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}

                                    {chosenPackage.price_breakdown && (
                                        <Table.Row>
                                            <Table.Cell colSpan={4}>
                                                <ul>
                                                    {chosenPackage.price_breakdown.map((price, index) => (
                                                        <li key={`price_breakdown_${index}`}>{price.value}</li>
                                                    ))}
                                                </ul>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}

                                    {chosenPackage.includes && (
                                        <Table.Row>
                                            <Table.Cell colSpan="4">
                                                <strong>Includes</strong>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}

                                    {chosenPackage.includes && (
                                        <Table.Row>
                                            <Table.Cell colSpan={4}>
                                                <ul>
                                                    {chosenPackage.includes.map((include, index) => (
                                                        <li key={`include${index}`}>{include.value}</li>
                                                    ))}
                                                </ul>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}

                                    {chosenPackage.excludes && (
                                        <Table.Row>
                                            <Table.Cell colSpan="4">
                                                <strong>Excludes</strong>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}

                                    {chosenPackage.excludes && (
                                        <Table.Row>
                                            <Table.Cell colSpan={4}>
                                                <ul>
                                                    {chosenPackage.excludes.map((exclude, index) => (
                                                        <li key={`exclude${index}`}>{exclude.value}</li>
                                                    ))}
                                                </ul>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                                </Table.Body>
                            </Table>
                        )}
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </>
    );
}

